<template>
  <div class="app-container">
    <!--查询组-->
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <el-form-item prop="keyword">
          <el-input
            v-model="listQuery.keyword"
            placeholder="请输入用户姓名/手机号"
            clearable
            @keyup.enter.native="SearchData"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="SearchData"
          >
            搜索
          </el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->
        <el-button
          v-auth="'User.create'"
          class="action-item"
          type="primary"
          icon="el-icon-edit"
          @click="HandleCreate"
        >添加</el-button>
        <el-button
          v-auth="'User.delete'"
          class="action-item"
          icon="el-icon-delete"
          @click="BatchDelete"
        >删除</el-button>
      </el-button-group>
    </div>
    <!--表开始-->
    <el-table
      ref="singleTable"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%"
      @sort-change="sortChange"
    >
      <el-table-column type="selection" />
      <el-table-column align="center" label="编号" width="50">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="name"
        label="姓名"
        show-overflow-tooltip
        width="120"
      />
      <el-table-column
        align="left"
        prop="phone"
        label="手机号"
        width="180"
        show-overflow-tooltip
      />
      <el-table-column
        align="center"
        label="状态"
        width="100"
        column-key="status"
        prop="status"
        :filters="[{ text: '启用', value: 1 }, { text: '禁用', value: 0 }]"
        :filter-method="filterHandler"
      >
        <template slot-scope="{ row }">
          <el-switch
            v-model="row.status"
            :active-value="1"
            :inactive-value="0"
            @change="changeState(row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="login_time"
        width="180"
        :formatter="timestampToTime"
        label="登录时间"
      />
      <el-table-column
        align="center"
        prop="create_time"
        width="180"
        label="创建时间"
      />
      <el-table-column align="center" prop="" label="操作">
        <template slot-scope="scopes" width="300">
          <el-button
            v-auth-all="['User.edit', 'User.reset_password']"
            type="warning"
            icon="el-icon-refresh"
            size="mini"
            @click="resetPwd(scopes.row)"
          >
            重置密码
          </el-button>
          <el-button
            v-auth="'User.edit'"
            type="primary"
            icon="el-icon-edit"
            size="mini"
            @click="HandleUpdate(scopes.row)"
          >
            编辑
          </el-button>
          <el-button
            v-auth="'User.delete'"
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="RowDelete(scopes.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      :page-sizes="[10,20,50,100, 200, 500,1000]"
      :page-size="100"
      @pagination="loadData"
    />
    <!--弹窗编辑/新增窗体-->
    <el-dialog
      :title="dialogStatus == 'create' ? '新增' : '编辑'"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        ref="dataForm"
        :rules="rules"
        :model="temp"
        label-position="left"
        label-width="100px"
        style="width: 400px; margin-left:50px;"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="temp.name" :disabled="dialogStatus != 'create'" />
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="temp.phone" :disabled="dialogStatus != 'create'" />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio v-model="temp.status" :label="1" border>
            启用
          </el-radio>
          <el-radio v-model="temp.status" :label="0" border>
            禁用
          </el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="ConfirmData">
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/user' // 和数据交互相关写在api 方便复用
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'
export default {
  name: 'User',
  components: { Pagination },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.temp.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      // api接口方法
      api,
      // 校验
      rules: {
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            pattern: /^[a-zA-Z0-9]+$/,
            required: true,
            message: '数字或英文，不包含特殊字符',
            trigger: 'blur'
          }
        ],
        confirmpassword: [{ validator: validatePass2, trigger: 'blur' }]
      },
      temp: {}
    }
  },
  created() {
    this.loadData() // 页面加载创建时加载数据
  },
  methods: {
    timestampToTime(row, column) {
      var date = new Date(row.login_time * 1000) // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
      const Y = date.getFullYear() + '-'
      const M =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1) + '-'
          : date.getMonth() + 1 + '-'
      const D =
        date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
      const h =
        date.getHours() < 10
          ? '0' + date.getHours() + ':'
          : date.getHours() + ':'
      const m =
        date.getMinutes() < 10
          ? '0' + date.getMinutes() + ':'
          : date.getMinutes() + ':'
      const s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    // 更新状态
    changeState(row) {
      this.api.SaveSimple({ id: row.id, status: row.status }).then(response => {
        this.$notify({
          title: '成功',
          message: response.message,
          type: 'success'
        })
      })
    },
    resetTemp() {
      this.temp = { id: undefined, status: 1 }
    },
    // 筛选
    filterHandler(value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    // 重置密码
    resetPwd(row) {
      this.$prompt('请输入重置密码', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[a-zA-Z0-9]+$/,
        inputErrorMessage: '数字或英文，不包含特殊字符',
        inputType: 'password'
      })
        .then(({ value }) => {
          this.api.ResetPwd({ id: row.id, password: value }).then(response => {
            this.$notify({
              title: '成功',
              message: response.message,
              type: 'success'
            })
          })
        })
        .catch(() => {})
    }
  }
}
</script>
